import { fileUploadConfig } from "@/utils/config";

/** The images and documents shown inline in a feed, for when the upload config names no types of its own. */
const DEFAULT_PASTABLE_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/webp",
  "image/gif",
  "image/bmp",
  "application/pdf",
];

/**
 * The MIME types a message composer takes from a paste or a drop: the upload config's images, documents, and text
 * files when it names any, otherwise the common images and PDF.
 */
export function pastableFileTypes(): string[] {
  if (fileUploadConfig.allowedMimeTypes.length === 0) return DEFAULT_PASTABLE_FILE_TYPES;
  return fileUploadConfig.allowedMimeTypes.filter(
    (type) => type.startsWith("image") || type.startsWith("application") || type.startsWith("text"),
  );
}
